<template>
  <div class="enroll-recruit-student">
    <PlatDataGridGrade grid-id="PeEnrollStudentRecruit"
                       show-label></PlatDataGridGrade>
  </div>
</template>

<script>
import PlatDataGridGrade from '../../../wrapper/grid/PlatDataGridGrade'
export default {
  name: 'EnrollRecruitStudent',
  components: {
    PlatDataGridGrade
  }
}
</script>

<style lang="scss">
  .enroll-recruit-student {
    height: 100%;
  }
</style>
